import { DatePicker } from "@fluentui/react-datepicker-compat";
import { Dropdown, Option } from "@fluentui/react-components";
import React, { useContext } from "react";
import { capitalize, formatDate } from "./utils";
import { ColumnOptionsContext } from "./ColumnOptions";
import {
  Column,
  DateFilter as DateFilterType,
  DateFilterOperator,
  dateFilterOperators,
} from "./types";

type Props = {
  column: Column;
};

export const DateFilter = ({ column }: Props) => {
  const filter = column.filter as DateFilterType;
  const { setFilter, strings, filterProps, id } =
    useContext(ColumnOptionsContext);

  let date1Props: any = filterProps
    ? filterProps[column.key]
      ? filterProps[column.key].date1
      : undefined
    : undefined;

  let date2Props: any = undefined;

  if (filter.operator === "isBetween") {
    date1Props = {
      ...(date1Props || {}),
      maxDate: filter.date2 ?? (date1Props ? date1Props.maxDate : undefined),
    };
    date2Props = filterProps
      ? filterProps[column.key]
        ? filterProps[column.key].date2
        : undefined
      : undefined;
    date2Props = {
      ...(date2Props || {}),
      minDate: filter.date1 ?? (date2Props ? date2Props.minDate : undefined),
    };
  }

  return (
    <div>
      <Dropdown
        value={strings[`dateFilterOperator${capitalize(filter.operator)}Label`]}
        selectedOptions={[filter.operator]}
        id={id ? `${id}-DateFilter-${column.key}` : undefined}
        onOptionSelect={(_, data) => {
          if (!data.optionValue) return;
          setFilter(column.key, {
            ...column.filter,
            operator: data.optionValue as DateFilterOperator,
          } as DateFilterType);
        }}
        style={{ marginBottom: 4 }}
      >
        {dateFilterOperators.map((o) => (
          <Option key={o} value={o}>
            {strings[`dateFilterOperator${capitalize(o)}Label`]}
          </Option>
        ))}
      </Dropdown>
      <DatePicker
        value={filter.date1 ?? undefined}
        onSelectDate={(date) => {
          setFilter(column.key, {
            ...column.filter,
            date1: date ?? null,
          } as DateFilterType);
        }}
        formatDate={(date) => (date ? formatDate(date) : "")}
        {...date1Props}
        style={{ marginBottom: 4 }}
        strings={strings["datePickerStrings"]}
      />
      {filter.operator === "isBetween" && (
        <DatePicker
          value={filter.date2 ?? undefined}
          id={id ? `${id}-DatePicker-${column.key}` : undefined}
          onSelectDate={(date) => {
            setFilter(column.key, {
              ...column.filter,
              date2: date ?? null,
            } as DateFilterType);
          }}
          formatDate={(date) => (date ? formatDate(date) : "")}
          {...date2Props}
          strings={strings["datePickerStrings"]}
        />
      )}
    </div>
  );
};
